import { ColRigth } from "./ColRigth";

export const Header = () => {
  return null;
};

Header.ColRigth = ColRigth;
